var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "recharge-root",
      class: { "ar-style": _vm.$i18n.locale === "ar" },
    },
    [
      _c(
        "div",
        {
          staticClass: "custom-nav-block",
          style: `padding-top:${_vm.barHeight}px`,
        },
        [
          _c("van-nav-bar", {
            staticClass: "van-bar",
            attrs: { title: "", "left-arrow": "" },
            on: { "click-left": _vm.closeWeb },
            scopedSlots: _vm._u([
              {
                key: "left",
                fn: function () {
                  return [
                    _c("img", {
                      staticClass: "left-nav",
                      attrs: {
                        src: require("@/assets/packageAssets/common/arrow01.png"),
                        alt: "",
                      },
                    }),
                  ]
                },
                proxy: true,
              },
              {
                key: "right",
                fn: function () {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "tit-right",
                        on: {
                          click: function ($event) {
                            _vm.showRules = true
                          },
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "left-nav",
                          attrs: {
                            src: require("@/assets/packageAssets/common/rules01.png"),
                            alt: "",
                          },
                        }),
                      ]
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _c("div", { staticClass: "recharge-content" }, [
        _vm.$i18n.locale === "ar"
          ? _c("img", {
              staticClass: "rec-fir-tit",
              attrs: { src: _vm.getMatchTitle("tit-bg-ar"), alt: "" },
            })
          : _vm.$i18n.locale === "es"
          ? _c("img", {
              staticClass: "rec-fir-tit",
              attrs: { src: _vm.getMatchTitle("tit-bg-es"), alt: "" },
            })
          : _vm.$i18n.locale === "fr"
          ? _c("img", {
              staticClass: "rec-fir-tit",
              attrs: { src: _vm.getMatchTitle("tit-bg-fr"), alt: "" },
            })
          : _vm.$i18n.locale === "id"
          ? _c("img", {
              staticClass: "rec-fir-tit",
              attrs: { src: _vm.getMatchTitle("tit-bg-id"), alt: "" },
            })
          : _vm.$i18n.locale === "pt"
          ? _c("img", {
              staticClass: "rec-fir-tit",
              attrs: { src: _vm.getMatchTitle("tit-bg-pt"), alt: "" },
            })
          : _vm.$i18n.locale === "tr"
          ? _c("img", {
              staticClass: "rec-fir-tit",
              attrs: { src: _vm.getMatchTitle("tit-bg-tr"), alt: "" },
            })
          : _c("img", {
              staticClass: "rec-fir-tit",
              attrs: { src: _vm.getMatchTitle("tit-bg-en"), alt: "" },
            }),
        _c("div", { staticClass: "rec-date-block" }, [
          _c("div", { staticClass: "rec-fir-date" }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("lang.commonM.k083")))]),
            _c("img", { attrs: { src: require("./images/clock.png") } }),
            _c("span", [_vm._v(_vm._s(_vm.showTime))]),
          ]),
        ]),
        _c("div", { staticClass: "rec-fir-con" }, [
          _c("div", { staticClass: "rec-fir-head" }, [
            _vm._v(_vm._s(_vm.$t("lang.commonM.k314")) + " 1"),
          ]),
          _c("div", { staticClass: "rec-fir-block" }, [
            _c("div", { staticClass: "rec-fir-reward" }, [
              _c("div", { staticClass: "fir-reward-l" }, [
                _vm.baseInfo
                  ? _c("span", { staticClass: "fir-reward-num" }, [
                      _vm._v(_vm._s(_vm.baseInfo.originAmount)),
                    ])
                  : _vm._e(),
                _c("img", {
                  staticClass: "fir-reward-coin",
                  attrs: { src: _vm.getMatchImg("coin"), alt: "" },
                }),
                _c("span", { staticClass: "fir-reward-tit" }, [
                  _vm._v(_vm._s(_vm.$t("lang.commonM.k302"))),
                ]),
              ]),
              _c("img", {
                staticClass: "fir-reward-c",
                attrs: { src: require("./images/up-t.png") },
              }),
              _c("div", { staticClass: "fir-reward-r" }, [
                _vm.baseInfo
                  ? _c("span", { staticClass: "fir-reward-num" }, [
                      _vm._v(" " + _vm._s(_vm.baseInfo.originAmount) + "+"),
                      _c("i", [
                        _vm._v(
                          _vm._s(
                            _vm.baseInfo.amount - _vm.baseInfo.originAmount
                          )
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _c("img", {
                  staticClass: "fir-reward-coin",
                  attrs: { src: _vm.getMatchImg("coin"), alt: "" },
                }),
                _c("div", { staticClass: "fir-reward-tit" }, [
                  _vm._v(_vm._s(_vm.$t("lang.commonM.k303"))),
                ]),
                _vm.baseInfo
                  ? _c("div", { staticClass: "reward-percent" }, [
                      _vm._v("+" + _vm._s(_vm.baseInfo.discountDesc)),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _c("div", { staticClass: "rec-fir-deliver" }, [
              _vm._m(0),
              _c("div", { staticClass: "rec-fir-deliver-text" }, [
                _vm._v(_vm._s(_vm.$t("lang.commonM.k086"))),
              ]),
              _vm._m(1),
            ]),
            _vm.baseInfo &&
            _vm.baseInfo.presentPropList &&
            _vm.baseInfo.presentPropList.length
              ? _c(
                  "div",
                  { staticClass: "rec-fir-fecture" },
                  [
                    _vm._l(
                      _vm.baseInfo.presentPropList,
                      function (item, index) {
                        return [
                          index > 0
                            ? _c("div", { staticClass: "fir-fecture-gap" })
                            : _vm._e(),
                          item.propType == 1
                            ? _c("div", { staticClass: "fir-fecture-item" }, [
                                _c("img", {
                                  attrs: { src: _vm.getMatchImg("chat-pass") },
                                }),
                                _c("div", [_vm._v("x" + _vm._s(item.number))]),
                              ])
                            : item.propType == 2
                            ? _c("div", { staticClass: "fir-fecture-item" }, [
                                _c("img", {
                                  attrs: { src: _vm.getMatchImg("video-pass") },
                                }),
                                _c("div", [_vm._v("x" + _vm._s(item.number))]),
                              ])
                            : item.propType == 4
                            ? _c("div", { staticClass: "fir-fecture-item" }, [
                                _c("img", {
                                  attrs: { src: _vm.getMatchImg("vip") },
                                }),
                                _c("div", [_vm._v("x" + _vm._s(item.number))]),
                              ])
                            : item.propType == 6
                            ? _c("div", { staticClass: "fir-fecture-item" }, [
                                _c("img", {
                                  attrs: { src: _vm.getMatchImg("call-pass") },
                                }),
                                _c("div", [_vm._v("x" + _vm._s(item.number))]),
                              ])
                            : item.propType == 9
                            ? _c("div", { staticClass: "fir-fecture-item" }, [
                                _c("img", {
                                  attrs: { src: _vm.getMatchImg("coupon") },
                                }),
                                _c("div", [_vm._v("x" + _vm._s(item.number))]),
                              ])
                            : item.propType == 15
                            ? _c("div", { staticClass: "fir-fecture-item" }, [
                                _c("img", {
                                  attrs: {
                                    src: _vm.getMatchImg("super-chat-pass"),
                                  },
                                }),
                                _c("div", [_vm._v("x" + _vm._s(item.number))]),
                              ])
                            : _vm._e(),
                        ]
                      }
                    ),
                  ],
                  2
                )
              : _vm._e(),
            _vm.baseInfo
              ? _c(
                  "div",
                  {
                    staticClass: "rec-fir-btn",
                    class: {
                      "cannot-claim": !_vm.baseInfo || !_vm.baseInfo.ifValid,
                    },
                    on: { click: _vm.handleToPay },
                  },
                  [
                    _vm.baseInfo.currencyIcon
                      ? _c("div", { staticClass: "btn-icon" }, [
                          _c("img", {
                            attrs: {
                              src: _vm._f("imgPath")(_vm.baseInfo.currencyIcon),
                            },
                          }),
                        ])
                      : _vm._e(),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.baseInfo.currency) +
                          _vm._s(_vm.handleDiv100(_vm.baseInfo.originPrice))
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
          ]),
          _c("div", { staticClass: "rec-fir-head" }, [
            _vm._v(_vm._s(_vm.$t("lang.commonM.k314")) + " 2"),
          ]),
          _c(
            "div",
            {
              staticClass: "rec-fir-block",
              staticStyle: { "margin-bottom": "0" },
            },
            [
              _c("div", { staticClass: "progress-head" }, [
                _vm._v(_vm._s(_vm.$t("lang.commonM.k315"))),
              ]),
              _vm.baseInfo &&
              _vm.baseInfo.taskProc &&
              _vm.baseInfo.taskProc.length
                ? _vm._l(_vm.baseInfo.taskProc, function (item) {
                    return _c(
                      "div",
                      { key: item.cfgId },
                      [
                        _c("div", { staticClass: "progtess-tips" }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("lang.commonM.k217"))),
                          ]),
                          _c("div", [
                            _c("img", {
                              attrs: { src: _vm.getMatchImg("coin") },
                            }),
                            _c("div", { staticStyle: { width: "2px" } }),
                            _c("span", [_vm._v("x" + _vm._s(item.reward))]),
                          ]),
                        ]),
                        _c(
                          "div",
                          { staticClass: "progress-block" },
                          [
                            _c("div", {
                              staticClass: "progress-bar",
                              style: {
                                width: `${(item.proc / item.target) * 100}%`,
                              },
                            }),
                            item.proc === 0
                              ? [
                                  _c("img", {
                                    staticClass: "progress-step1",
                                    attrs: {
                                      src: require("./images/check-off.png"),
                                    },
                                  }),
                                  _c("img", {
                                    staticClass: "progress-step2",
                                    attrs: {
                                      src: require("./images/check-off.png"),
                                    },
                                  }),
                                  _c("img", {
                                    staticClass: "progress-step3",
                                    attrs: {
                                      src: require("./images/check-off.png"),
                                    },
                                  }),
                                ]
                              : _vm._e(),
                            item.proc === 1
                              ? [
                                  _c("img", {
                                    staticClass: "progress-step1",
                                    attrs: {
                                      src: require("./images/check.png"),
                                    },
                                  }),
                                  _c("img", {
                                    staticClass: "progress-step2",
                                    attrs: {
                                      src: require("./images/check-off.png"),
                                    },
                                  }),
                                  _c("img", {
                                    staticClass: "progress-step3",
                                    attrs: {
                                      src: require("./images/check-off.png"),
                                    },
                                  }),
                                ]
                              : _vm._e(),
                            item.proc === 2
                              ? [
                                  _c("img", {
                                    staticClass: "progress-step1",
                                    attrs: {
                                      src: require("./images/check.png"),
                                    },
                                  }),
                                  _c("img", {
                                    staticClass: "progress-step2",
                                    attrs: {
                                      src: require("./images/check.png"),
                                    },
                                  }),
                                  _c("img", {
                                    staticClass: "progress-step3",
                                    attrs: {
                                      src: require("./images/check-off.png"),
                                    },
                                  }),
                                ]
                              : _vm._e(),
                            item.proc === 3
                              ? [
                                  _c("img", {
                                    staticClass: "progress-step1",
                                    attrs: {
                                      src: require("./images/check.png"),
                                    },
                                  }),
                                  _c("img", {
                                    staticClass: "progress-step2",
                                    attrs: {
                                      src: require("./images/check.png"),
                                    },
                                  }),
                                  _c("img", {
                                    staticClass: "progress-step3",
                                    attrs: {
                                      src: require("./images/check.png"),
                                    },
                                  }),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                        _vm._m(2, true),
                        !item.ifDone
                          ? [
                              _c(
                                "div",
                                { staticClass: "rec-fir-btn cannot-claim" },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("lang.commonM.k073"))),
                                  ]),
                                ]
                              ),
                            ]
                          : [
                              !item.ifClaimed
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "rec-fir-btn",
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleClaim(item)
                                        },
                                      },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("lang.commonM.k073"))
                                        ),
                                      ]),
                                    ]
                                  )
                                : _c(
                                    "div",
                                    { staticClass: "rec-fir-btn cannot-claim" },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("lang.commonM.k074"))
                                        ),
                                      ]),
                                    ]
                                  ),
                            ],
                      ],
                      2
                    )
                  })
                : _vm._e(),
            ],
            2
          ),
        ]),
      ]),
      _vm.showRules
        ? _c("div", { staticClass: "mask" }, [
            _c("div", { staticClass: "dia-con" }, [
              _c("p", { staticClass: "dia-tit" }, [
                _vm._v(_vm._s(_vm.$t("lang.commonM.k111"))),
              ]),
              _c("p", { staticClass: "rules-item" }, [
                _vm._v("1." + _vm._s(_vm.$t("lang.commonM.k061"))),
              ]),
              _c("p", { staticClass: "rules-item" }, [
                _vm._v("2." + _vm._s(_vm.$t("lang.commonM.k316"))),
              ]),
              _c("p", { staticClass: "rules-item" }, [
                _vm._v("3." + _vm._s(_vm.$t("lang.commonM.k317"))),
              ]),
              _c("p", { staticClass: "rules-item" }, [
                _vm._v("4." + _vm._s(_vm.$t("lang.commonM.k318"))),
              ]),
              _c(
                "div",
                {
                  staticClass: "rules-btn",
                  on: {
                    click: function ($event) {
                      _vm.showRules = false
                    },
                  },
                },
                [_vm._v("OK")]
              ),
            ]),
          ])
        : _vm._e(),
      _vm.showCongra
        ? _c("div", { staticClass: "mask" }, [
            _c("div", { staticClass: "dia-con" }, [
              _c("p", { staticClass: "dia-tit" }, [
                _vm._v(_vm._s(_vm.$t("lang.commonM.k147")) + " !"),
              ]),
              _c("div", { staticClass: "reward-item" }, [
                _c("img", {
                  attrs: { src: _vm.getMatchImg("coins"), alt: "" },
                }),
                _c("span", [_vm._v("x" + _vm._s(_vm.reward))]),
              ]),
              _c(
                "div",
                {
                  staticClass: "rules-btn",
                  on: {
                    click: function ($event) {
                      _vm.showCongra = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("lang.ok")))]
              ),
            ]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "deliver-l" }, [_c("div")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "deliver-r" }, [_c("div")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "progress-flag" }, [
      _c("span", { staticClass: "progress-flag0" }, [_vm._v("0")]),
      _c("span", { staticClass: "progress-flag1" }, [_vm._v("1")]),
      _c("span", { staticClass: "progress-flag2" }, [_vm._v("2")]),
      _c("span", { staticClass: "progress-flag3" }, [_vm._v("3")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }